
import { BlogSection } from '@/types/blog';

export const coachingUmfeldSection: BlogSection = {
  id: 'coaching-umfeld',
  title: 'Mein Coaching-Umfeld: Natur und Technologie vereint',
  content: `
    <p>
      Mein Coaching-Umfeld umfasst die Metropolregion Nürnberg mit der wunderbaren Möglichkeit zum 
      <a href="/outdoor-coaching" class="text-primary hover:underline">Outdoor-Coaching am Rothsee</a>. 
      Die Natur bietet hier einen idealen Raum für Reflexion und Klarheit. Gleichzeitig bin ich 
      bundesweit tätig und begleite Klienten ortsunabhängig – sei es online oder persönlich vor Ort.
    </p>
    
    <p>
      Im Finanzcoaching geht es nicht nur um Zahlen, sondern um die ganzheitliche Betrachtung von:
    </p>
    
    <ul class="my-4 space-y-2">
      <li class="flex items-start">
        <span class="text-primary mr-2">✓</span>
        <span>Emotionen und ihre Auswirkung auf finanzielle Entscheidungen</span>
      </li>
      <li class="flex items-start">
        <span class="text-primary mr-2">✓</span>
        <span>Tief verwurzelte Überzeugungen, die den Umgang mit Geld bestimmen</span>
      </li>
      <li class="flex items-start">
        <span class="text-primary mr-2">✓</span>
        <span>Langfristige Perspektiven für finanzielle Sicherheit und Freiheit</span>
      </li>
    </ul>
    
    <p>
      Mein Ansatz verbindet Coaching mit fundiertem Wissen, um nicht nur finanzielle Klarheit zu schaffen, 
      sondern auch innere Blockaden zu lösen.
    </p>
  `
};
